import {
  CLEAN_STATE,
  FETCH_MENU_OPTIONS,
  FETCH_MENU_OPTIONS_FAILED,
  FETCH_MENU_OPTIONS_SUCCESS,
  STRUCTURE_OPTION_CHECKED,
  STRUCTURE_OPTION_CLEAR,
} from '@Pages/RetroSynthesis/StructureOption/constants';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

export const structureOptionCheckedAction = ({ type, targetRect, data, trackingContext, routeType }) => ({
  type: STRUCTURE_OPTION_CHECKED,
  payload: { type, targetRect, data, trackingContext, routeType },
});

// Clear structure options data but keeps synthesis options
export const structureOptionClearAction = () => ({
  type: STRUCTURE_OPTION_CLEAR,
});

export const clearStateAction = () => ({
  type: CLEAN_STATE,
});

export const fetchSynthesisPlannerMenuOptionsAction = () => async (dispatch) => {
  dispatch({ type: FETCH_MENU_OPTIONS });
  try {
    const result = await MessageBroker.send(RequestUrls.plannerMenuItems);
    dispatch({
      type: FETCH_MENU_OPTIONS_SUCCESS,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: FETCH_MENU_OPTIONS_FAILED,
      payload: e,
    });
    Logger.error('Get Synthesis menu items error:', e);
  }
};
